export const optionsValues = {
  FIVE: '5',
  TEN: '10',
  ALL: 'all',
  CUSTOM: 'custom',
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/consts/options.js